// src/lib/shiftSanitize.js
// 簡易 HTML 消毒：僅允許常見標籤與有限屬性（公告內容）

const ALLOWED_TAGS = new Set(['P', 'BR', 'B', 'STRONG', 'I', 'EM', 'U', 'UL', 'OL', 'LI', 'SPAN', 'IMG', 'DIV']);

function sanitizeStyle(style) {
  if (!style) return '';
  const parts = String(style).split(';').map((s) => s.trim()).filter(Boolean);
  const out = [];
  for (const p of parts) {
    const [rawKey, ...rest] = p.split(':');
    const key = String(rawKey || '').trim().toLowerCase();
    const val = rest.join(':').trim();
    if (!val) continue;
    if (key === 'color' || key === 'font-weight' || key === 'font-style' || key === 'text-decoration') {
      if (/^#[0-9a-fA-F]{3,8}$/.test(val) || /^rgb\([\d\s,]+\)$/.test(val) || /^(bold|normal|italic|underline|none)$/i.test(val)) {
        out.push(`${key}:${val}`);
      }
    }
    if (key === 'max-width' || key === 'width' || key === 'margin' || key === 'border-radius') {
      if (/^[\d.%pxem\s]+$/i.test(val)) out.push(`${key}:${val}`);
    }
  }
  return out.join(';');
}

function sanitizeImgSrc(src) {
  const s = String(src || '').trim();
  if (!s) return '';
  if (s.startsWith('/uploads/') || s.startsWith('https://') || s.startsWith('http://')) return s;
  return '';
}

/**
 * @param {string} html
 * @returns {string}
 */
export function sanitizeShiftHtml(html) {
  if (!html || typeof document === 'undefined') {
    // SSR／無 DOM：剝除 script 標籤的粗略後備
    return String(html || '')
      .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '')
      .replace(/\son\w+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, '');
  }
  const wrap = document.createElement('div');
  wrap.innerHTML = String(html);
  const walk = (node) => {
    const children = [...node.childNodes];
    for (const child of children) {
      if (child.nodeType === 3) continue; // text
      if (child.nodeType !== 1) {
        child.remove();
        continue;
      }
      const tag = child.tagName;
      if (!ALLOWED_TAGS.has(tag)) {
        // 保留文字內容
        while (child.firstChild) node.insertBefore(child.firstChild, child);
        child.remove();
        continue;
      }
      // 清屬性
      const attrs = [...child.attributes];
      for (const a of attrs) {
        const name = a.name.toLowerCase();
        if (name === 'style') {
          const cleaned = sanitizeStyle(a.value);
          if (cleaned) child.setAttribute('style', cleaned);
          else child.removeAttribute('style');
        } else if (tag === 'IMG' && name === 'src') {
          const src = sanitizeImgSrc(a.value);
          if (src) child.setAttribute('src', src);
          else child.removeAttribute('src');
        } else if (tag === 'IMG' && (name === 'alt' || name === 'width' || name === 'height')) {
          // keep
        } else {
          child.removeAttribute(a.name);
        }
      }
      if (tag === 'IMG' && !child.getAttribute('src')) {
        child.remove();
        continue;
      }
      walk(child);
    }
  };
  walk(wrap);
  return wrap.innerHTML;
}
